<template>
  <base-modal @close="$emit('close')" :confirmTitle="text" @confirm="$emit('accept')">
    <div class="p-6 space-y-2">
      <p class="text-center text-xl font-medium mb-4">Konfirmasi</p>
      <p class="text-gray-600 text-center">
        <template v-if="isPermanent">
          Apakah Anda ingin <b>{{ text.toLowerCase() }}</b>?
          File ini akan disimpan ke <b>Recycle Bin</b>, periksa ulang untuk memastikan.
        </template>
        <template v-else>
          Apa anda ingin <b>{{ text }}</b>? Anda akan keluar dari aplikasi dan memerlukan OTP untuk masuk kembali.
        </template>
      </p>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from "../../layout/BaseModal.vue";
export default {
  components: { BaseModal },
  props: {
    text: {
      type: String,
      required: true,
    },
    isPermanent: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style></style>
